export const FRANCE_HOME_PAGE = 'https://www.americanexpress.com/fr-fr/';
export const INAV_VARIANTS = {
  CONTROL: 'control',
  INAV_VAR_A: 'variantA',
};
export const GLOBAL_HEADER_NAME = 'axp-global-header';
export const GLOBAL_FOOTER_NAME = 'axp-footer';
